import FormInput from './formInput-TEMPLATE_VERSION'

export default FormInput
